// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Index Css */\n\n.row {\n  --bs-gutter-x: 1rem;\n}\n", "",{"version":3,"sources":["webpack://./src/Index.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,mBAAmB;AACrB","sourcesContent":["/* Index Css */\n\n.row {\n  --bs-gutter-x: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
